import React, { useEffect } from 'react';
import ImageCarousel from './ImageCarousel';
import './AboutUsHomePage.css';

const carouselImages = [
    {
        src: `${process.env.PUBLIC_URL}/assets/davidS-Home.JPEG`,
        alt: "Pilots in a cockpit",
        //caption: "PilotHelper provides support for aviation professionals"
    },
    {
        src: `${process.env.PUBLIC_URL}/assets/CaptainJoe-Home.JPG`,
        alt: "Airborne pilots",
    },
    {
        src: `${process.env.PUBLIC_URL}/assets/ChrisPohl-Home.JPEG`,
        alt: "Pilot training session",
        //caption: "Our peer support training in action"
    },

    {
        src: `${process.env.PUBLIC_URL}/assets/EllieRyan-Home.PNG`,
        alt: "Airborne pilots",
        //caption: "Steady skies"
    },
    {
        src: `${process.env.PUBLIC_URL}/assets/PaulHolte-Home.JPG`,
        alt: "Solo Pilot",
        //caption: "Ready for lift-off"
    }
];

const AboutUsHomePage = () => {

    // Preload the first carousel image for better LCP
    useEffect(() => {
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = carouselImages[0].src;
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    return (
        <div className='py-5' style={{ backgroundColor: '#ffffff' }}>
            <div className='container'>
                <div className='row align-items-center justify-content-center'>
                    {/* Image carousel */}
                    <div className='col-lg-5 col-md-6 mb-4 mb-lg-0 d-flex flex-column'>
                        <ImageCarousel images={carouselImages} interval={5000} />
                    </div>
                    {/* Stats boxes - centered in remaining space */}
                    <div className='col-lg-4 col-md-6 d-flex justify-content-center align-items-center ps-lg-3'>
                        <div className="d-flex flex-column gap-3 stat-boxes-wrapper">
                            {/* Box 1 */}
                            <div className="stat-box shadow-sm p-4">
                                <h3 className="stat-number">100+</h3>
                                <p className="stat-text">countries reached</p>
                            </div>
                            {/* Box 2 */}
                            <div className="stat-box shadow-sm p-4">
                                <h3 className="stat-number">100K+</h3>
                                <p className="stat-text">pilots reached worldwide</p>
                            </div>
                            {/* Box 3 */}
                            <div className="stat-box shadow-sm p-4">
                                <h3 className="stat-number">15+</h3>
                                <p className="stat-text">aviation organizations partnered</p>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    );
};

export default AboutUsHomePage;